export default function Footer() {
    return (
        <footer className="mt-28">
        </footer>
    );
}
